import { computed, inject } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

/**
 * Generisches API Composable
 * Bietet Zugriff auf den zentralen API Store und grundlegende API-Funktionen
 */
export function useApi() {
  const apiStore = useApiStore()
  const myportal = inject('myportal')

  // Initialisiere API Service falls noch nicht geschehen
  if (myportal && !apiStore.apiService) {
    apiStore.initializeApiService(myportal)
  }

  return {
    // Store-Referenz
    store: apiStore,
    
    // Globale States
    globalLoading: computed(() => apiStore.isGlobalLoading),
    initialized: computed(() => apiStore.isInitialized),
    hasErrors: computed(() => apiStore.hasAnyErrors),
    
    // Actions
    loadInitialData: () => apiStore.loadInitialData(),
    clearCache: () => apiStore.clearCache(),
    getCacheStats: () => apiStore.getCacheStats(),
    
    // Utility
    createRating: (ratingData) => apiStore.createRating(ratingData),
    submitBookingRequest: (apartment, payload) => apiStore.submitBookingRequest(apartment, payload),
    sendContactMessage: (mailTo, form) => apiStore.sendContactMessage(mailTo, form)
  }
}